import { render, staticRenderFns } from "./Rule_Football.vue?vue&type=template&id=d466fe9a&scoped=true&"
import script from "./Rule_Football.vue?vue&type=script&lang=js&"
export * from "./Rule_Football.vue?vue&type=script&lang=js&"
import style0 from "./Rule_Football.vue?vue&type=style&index=0&id=d466fe9a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d466fe9a",
  null
  
)

export default component.exports